import { AxiosInstance } from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

import * as requestUrl from "../../constants/request";
import { FetchStatementsResult } from "./statements-state";
import { addNotification } from "store/notification/notification-utils";
import { extractError } from "utility/utils";
import { FilterProps } from "store/common";

const constructStatementsUrl = (
  { accountInformationId, transactionYear }: Partial<FilterProps> = {},
  statementsUrl: URL,
): URL => {
  if (accountInformationId !== undefined && accountInformationId !== null) {
    statementsUrl.searchParams.append(
      "AccountInformationId",
      accountInformationId.toString(),
    );
  }
  if (!!transactionYear) {
    statementsUrl.searchParams.append("TransactionYear", transactionYear);
  }
  return statementsUrl;
};

export type FetchStatements = typeof fetchStatements;

export const fetchStatements = createAsyncThunk<
  FetchStatementsResult,
  {
    request: AxiosInstance;
    data: FilterProps;
  }
>("statements/fetchStatements", async ({ request, data }, thunkApi) => {
  let statementsUrl = new URL(
    requestUrl.FT_STATEMENTS,
    requestUrl.FT_REQUEST_BASE_URL,
  );
  statementsUrl = constructStatementsUrl(data, statementsUrl);
  try {
    const response = await request.post(statementsUrl.toString(), data);
    return { results: response.data };
  } catch (error) {
    const errCode = extractError(error);
    const { isSlideOpen } = (thunkApi.getState() as any).common;
    addNotification(thunkApi.dispatch as any, isSlideOpen, {
      messages: errCode,
      type: "ERROR",
      closable: true,
    });
    return thunkApi.rejectWithValue(null);
  }
});
